/**
 * The calorie value provided by each Fresh meal-plan pouch size.
 *
 * This module deliberately has no model dependencies so that UI-only consumers,
 * such as Storybook, can use it without initialising the primary-models client.
 */
export const MEAL_PLAN_CALORIES = {
  A: 150,
  B: 200,
  C: 250,
  D: 300,
  E: 350,
  F: 400,
} as const;
